import m from "./ReoForm.mjs";
import r from "./ReoFormList/index.mjs";
import t from "./ReoFormItem/index.mjs";
import "../../depend/rc-field-form/es/index.mjs";
import e from "./hooks/useForm.mjs";
import s from "../../depend/rc-field-form/es/useWatch.mjs";
const o = m;
o.Item = t;
o.useReoForm = e;
o.useWatch = s;
o.List = r;
export {
  t as ReoFormItem,
  r as ReoFormList,
  o as default,
  e as useForm,
  s as useWatch
};
//# sourceMappingURL=index.mjs.map
